(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-catalogue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT = '[data-cb-cat]';
    const VIEW_KEY = 'cb-cat-view';
    const FAV_KEY = 'cb-cat-favourites';

    const read = (key, fallback) => {
      try {
        return JSON.parse(localStorage.getItem(key)) ?? fallback;
      } catch {
        return fallback;
      }
    };
    const write = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {}
    };

    const setView = (root, view) => {
      const grid = root.querySelector('[data-cb-cat-grid]');
      if (grid) grid.dataset.view = view;
      for (const button of root.querySelectorAll('[data-cb-cat-view]')) {
        button.setAttribute('aria-pressed', String(button.dataset.cbCatView === view));
      }
    };

    const setFavourites = (root) => {
      const favourites = read(FAV_KEY, []);
      for (const button of root.querySelectorAll('[data-cb-cat-fav]')) {
        button.setAttribute('aria-pressed', String(favourites.includes(button.dataset.cbCatFav)));
      }
    };

    const init = (root) => {
      // With the layout buttons turned off, the page stays on the grid whatever was picked on another page.
      setView(root, root.querySelector('[data-cb-cat-view]') ? read(VIEW_KEY, 'grid') : 'grid');
      setFavourites(root);
    };

    // Cards elsewhere on the page can filter this catalogue (snippets/cb-filter-link). Each follows the current URL:
    // it is marked active while its value is applied, and its link then removes that value instead of adding it.
    // A card highlighted in the editor is only marked while no card's filter is applied, so one card shows at a time.
    const syncFilterLinks = () => {
      const params = new URLSearchParams(location.search);
      const links = [...document.querySelectorAll('a[data-cb-cat-filter]')];
      const applied = links.filter((link) => params.getAll(link.dataset.cbCatFilter).includes(link.dataset.cbCatValue));
      for (const link of links) {
        const url = new URL(location.href);
        url.searchParams.delete(link.dataset.cbCatFilter);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        if (!applied.includes(link)) url.searchParams.append(link.dataset.cbCatFilter, link.dataset.cbCatValue);
        url.hash = 'products';
        link.href = url.href;
      }
      for (const card of document.querySelectorAll('a[data-cb-cat-filter], [data-cb-highlight]')) {
        const active = applied.length ? applied.includes(card) : card.hasAttribute('data-cb-highlight');
        card.classList.toggle('is-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      }
    };

    // Phone/tablet filter panel. The page behind it is locked while any panel is open.
    const syncScrollLock = () => {
      document.documentElement.classList.toggle('cb-cat-filters-open', !!document.querySelector('.cb-cat--filters-open'));
    };

    const setDrawer = (root, open) => {
      root.classList.toggle('cb-cat--filters-open', open);
      root.querySelector('[data-cb-cat-open]')?.setAttribute('aria-expanded', String(open));
      syncScrollLock();
    };

    const closeDrawer = (root) => {
      const hadFocus = root.querySelector('.cb-cat__sidebar')?.contains(document.activeElement);
      setDrawer(root, false);
      if (hadFocus) root.querySelector('[data-cb-cat-open]')?.focus({ preventScroll: true });
    };

    // A selector for the same control in the re-rendered section, so keyboard focus survives the swap.
    const FOCUS_KEYS = ['[data-cb-cat-open]', '.cb-cat__sidebar-close', '[data-cb-cat-view="grid"]', '[data-cb-cat-view="list"]', '.cb-cat__clear'];
    const focusSelector = (element) => {
      if (element.name) {
        const name = `[name="${CSS.escape(element.name)}"]`;
        return element.type === 'checkbox' ? `${name}[value="${CSS.escape(element.value)}"]` : name;
      }
      if (element.id) return `#${CSS.escape(element.id)}`;
      return FOCUS_KEYS.find((selector) => element.matches(selector)) || null;
    };

    const pending = new Map();

    // The filters, sort and page the catalogues are showing. Same-page links like #products don't change these.
    let shownSearch = location.search;

    // Fetches the section for a new URL (Section Rendering API) and swaps it in without a page reload.
    // A newer request for the same section cancels the older one, so quick clicks can't land out of order.
    const load = async (root, url, { push = true, scroll = false } = {}) => {
      const id = root.dataset.sectionId;
      const target = new URL(url, location.href);
      target.searchParams.delete('section_id');
      const request = new URL(target);
      request.searchParams.set('section_id', id);

      pending.get(id)?.abort();
      const controller = new AbortController();
      pending.set(id, controller);
      root.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(request, { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector(ROOT);
        if (!fresh) throw new Error('Section missing');

        // Carry over what the shopper changed on the page: collapsed filters, the open panel and focus.
        const current = document.querySelector(`${ROOT}[data-section-id="${CSS.escape(id)}"]`) || root;
        for (const details of current.querySelectorAll('details.cb-cat-filter:not([open])')) {
          fresh.querySelector(`#${CSS.escape(details.id)}`)?.removeAttribute('open');
        }
        const drawerOpen = current.classList.contains('cb-cat--filters-open');
        const hadFocus = current.contains(document.activeElement);
        const focus = hadFocus ? focusSelector(document.activeElement) : null;

        current.replaceWith(fresh);
        setDrawer(fresh, drawerOpen);
        init(fresh);
        if (hadFocus) {
          // The same control if it still exists, else the panel's close button or the results.
          const next = (focus && fresh.querySelector(focus)) || fresh.querySelector(drawerOpen ? '.cb-cat__sidebar-close' : '.cb-cat__results');
          next?.focus({ preventScroll: true });
        }
        target.hash = '';
        if (push) history.pushState({ cbCat: true }, '', target);
        shownSearch = target.search;
        syncFilterLinks();
        // The #products anchor keeps the catalogue heading clear of the sticky header.
        if (scroll) (fresh.querySelector('.cb-cat__anchor') || fresh).scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = target.href;
      } finally {
        if (pending.get(id) === controller) pending.delete(id);
      }
    };

    // Builds the URL from the form, including the sidebar inputs linked to it with form="…".
    const formUrl = (form) => {
      const params = new URLSearchParams();
      // Price ranges that may be ticked together combine into one from–to span.
      const spans = new Map();
      for (const element of form.elements) {
        // A ticked price range sets Shopify's from/to price parameters.
        if (element.matches('[data-cb-price-bucket]')) {
          if (!element.checked || element.disabled) continue;
          const list = element.closest('[data-cb-price-multi]');
          if (list) {
            const span = spans.get(list) || { gte: [], lte: [], gteName: element.dataset.gteName, lteName: element.dataset.lteName };
            span.gte.push(element.dataset.gte || '');
            span.lte.push(element.dataset.lte || '');
            spans.set(list, span);
            continue;
          }
          if (element.dataset.gte) params.append(element.dataset.gteName, element.dataset.gte);
          if (element.dataset.lte) params.append(element.dataset.lteName, element.dataset.lte);
          continue;
        }
        if (!element.name || element.disabled || element.value === '') continue;
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) continue;
        if (element.dataset.cbPriceMax && Number(element.value) >= Number(element.dataset.cbPriceMax)) continue;
        params.append(element.name, element.value);
      }
      // An open end on any ticked range (e.g. "Under $120" or "$240+") leaves that end of the span open.
      for (const span of spans.values()) {
        if (!span.gte.includes('')) params.append(span.gteName, String(Math.min(...span.gte.map(Number))));
        if (!span.lte.includes('')) params.append(span.lteName, String(Math.max(...span.lte.map(Number))));
      }
      const query = params.toString();
      return (form.getAttribute('action') || location.pathname) + (query ? `?${query}` : '');
    };

    // getAttribute, not form.id: a product form's <input name="id"> shadows the form's id property.
    const ownForm = (form) => (form?.getAttribute?.('id') || '').startsWith('cb-cat-form-') ? form : null;

    document.addEventListener('change', (event) => {
      const form = ownForm(event.target.form);
      const root = form?.closest(ROOT);
      if (!root) return;
      // Price ranges are one choice (unless the filter lets several be ticked): ticking one clears the others.
      if (event.target.matches('[data-cb-price-bucket]') && event.target.checked && !event.target.closest('[data-cb-price-multi]')) {
        for (const other of event.target.closest('ul')?.querySelectorAll('[data-cb-price-bucket]') ?? []) {
          if (other !== event.target) other.checked = false;
        }
      }
      load(root, formUrl(form));
    });

    document.addEventListener('submit', (event) => {
      const form = ownForm(event.target);
      const root = form?.closest(ROOT);
      if (!root) return;
      event.preventDefault();
      load(root, formUrl(form));
    });

    // Live label + track fill while dragging the price slider.
    document.addEventListener('input', (event) => {
      const range = event.target.closest?.('.cb-cat-price__range');
      if (!range) return;
      const wrap = range.closest('.cb-cat-price');
      wrap.style.setProperty('--cbk-price-pct', `${(range.value / range.max) * 100}%`);
      const label = wrap.querySelector('[data-cb-price-label]');
      if (label) label.textContent = `${wrap.dataset.symbol}${Number(range.value).toFixed(2)}`;
    });

    // Adds the next page's cards under the current ones. The button is a plain link, so it opens that page if this fails.
    const loadMore = async (root, button) => {
      button.setAttribute('aria-busy', 'true');
      try {
        const request = new URL(button.href, location.href);
        request.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(request);
        if (!response.ok) throw new Error(String(response.status));
        const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(ROOT);
        const items = [...(fresh?.querySelectorAll('.cb-cat__item') ?? [])];
        const footer = fresh?.querySelector('.cb-cat__footer');
        if (!items.length || !footer) throw new Error('Nothing to add');
        root.querySelector('[data-cb-cat-grid]').append(...items);
        root.querySelector('.cb-cat__footer').replaceWith(footer);
        setFavourites(root);
        items[0].querySelector('.cb-cat-card__title a')?.focus({ preventScroll: true });
      } catch {
        location.href = button.href;
      }
    };

    document.addEventListener('click', (event) => {
      const more = event.target.closest?.('[data-cb-cat-more]');
      if (more) {
        const root = more.closest(ROOT);
        if (!root || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        if (more.getAttribute('aria-busy') !== 'true') loadMore(root, more);
        return;
      }

      // A filter's "Guide" opens its short text under the heading.
      const guide = event.target.closest?.('[data-cb-cat-guide]');
      if (guide) {
        const open = guide.getAttribute('aria-expanded') !== 'true';
        guide.setAttribute('aria-expanded', String(open));
        const panel = document.getElementById(guide.getAttribute('aria-controls'));
        if (panel) panel.hidden = !open;
        return;
      }

      const link = event.target.closest?.('a[data-cb-cat-link]');
      if (link) {
        const root = link.closest(ROOT);
        if (!root || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        load(root, link.href, { scroll: link.dataset.cbCatLink === 'page' });
        return;
      }

      // A card elsewhere on the page that filters this catalogue (snippets/cb-filter-link).
      const filterLink = event.target.closest?.('a[data-cb-cat-filter]');
      if (filterLink) {
        const root = document.querySelector(ROOT);
        if (!root || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        load(root, filterLink.href, { scroll: true });
        return;
      }

      const viewButton = event.target.closest?.('[data-cb-cat-view]');
      if (viewButton) {
        write(VIEW_KEY, viewButton.dataset.cbCatView);
        for (const root of document.querySelectorAll(ROOT)) setView(root, viewButton.dataset.cbCatView);
        return;
      }

      const favourite = event.target.closest?.('[data-cb-cat-fav]');
      if (favourite) {
        const favourites = new Set(read(FAV_KEY, []));
        const id = favourite.dataset.cbCatFav;
        if (favourites.has(id)) favourites.delete(id);
        else favourites.add(id);
        write(FAV_KEY, [...favourites]);
        for (const root of document.querySelectorAll(ROOT)) setFavourites(root);
        return;
      }

      const opener = event.target.closest?.('[data-cb-cat-open]');
      if (opener) {
        const root = opener.closest(ROOT);
        if (!root) return;
        setDrawer(root, true);
        root.querySelector('.cb-cat__sidebar-close')?.focus({ preventScroll: true });
        return;
      }

      const closer = event.target.closest?.('[data-cb-cat-close]');
      if (closer) {
        const root = closer.closest(ROOT);
        if (root) closeDrawer(root);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const root of document.querySelectorAll('.cb-cat--filters-open')) closeDrawer(root);
    });

    // Same-page links like #products fire popstate too. Reloading for those would drop what Load more added.
    window.addEventListener('popstate', () => {
      if (location.search === shownSearch) return;
      for (const root of document.querySelectorAll(ROOT)) load(root, location.href, { push: false });
    });

    const initAll = () => {
      document.querySelectorAll(ROOT).forEach(init);
      syncFilterLinks();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(ROOT).forEach(init);
      syncFilterLinks();
      syncScrollLock();
    });
    document.addEventListener('shopify:section:unload', () => setTimeout(syncScrollLock));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-featured-frames"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT = '[data-cb-frames]';

    const applyFilter = (root, value) => {
      for (const pill of root.querySelectorAll('[data-cb-filter]')) {
        pill.setAttribute('aria-pressed', String(pill.dataset.cbFilter === value));
      }

      let shown = 0;
      for (const card of root.querySelectorAll('[data-cb-filter-keys]')) {
        const match = value === 'all' || card.dataset.cbFilterKeys.split(' ').includes(value);
        card.hidden = !match;
        if (match) shown += 1;
      }

      const empty = root.querySelector('[data-cb-frames-empty]');
      if (empty) empty.hidden = shown > 0;
    };

    document.addEventListener('click', (event) => {
      const pill = event.target.closest?.('[data-cb-filter]');
      const root = pill?.closest(ROOT);
      if (root) applyFilter(root, pill.dataset.cbFilter);
    });

    // In the theme editor, show a card when it's selected even if the active filter hides it.
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest?.('[data-cb-filter-keys]');
      const root = card?.closest(ROOT);
      if (root && card.hidden) applyFilter(root, 'all');
    });

    // Other sections (e.g. [CB] Playing tactics) can filter this grid by dispatching
    // a bubbling 'cb:frames-filter' event on it with { detail: { value } }.
    document.addEventListener('cb:frames-filter', (event) => {
      const root = event.target.closest?.(ROOT);
      if (root) applyFilter(root, event.detail?.value || 'all');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-finder-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The quiz on this page: [CB] Racket matcher or [CB] Racket finder quiz.
    const QUIZ = '[data-cb-rmatch], [data-cb-quiz-section]';

    // Fill [count] with the number of questions in the quiz on this page.
    const fillCounts = () => {
      const quiz = document.querySelector(QUIZ);
      const total = quiz ? quiz.querySelectorAll('[data-cb-rmatch-question], [data-cb-quiz-question]').length : 0;
      if (!total) return;
      for (const el of document.querySelectorAll('[data-cb-fintro-count]')) el.textContent = String(total);
    };

    // "Start the racket finder" buttons scroll to the quiz when it's on this page and focus its first answer.
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-cb-fintro-start]');
      if (!button) return;
      const quiz = document.querySelector(QUIZ);
      if (!quiz) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      quiz.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      const first = quiz.querySelector('.is-active [data-cb-rmatch-option], [data-cb-rmatch-option], [data-cb-quiz-option]');
      if (first) window.setTimeout(() => first.focus({ preventScroll: true }), reduce ? 0 : 600);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillCounts);
    else fillCounts();
    document.addEventListener('shopify:section:load', fillCounts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-finder-next"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // "Retake finder" restarts the racket quiz on this page (Racket matcher or Racket finder quiz) and scrolls to it;
    // with no quiz on the page it follows its link.
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-cb-fnext-retake]');
      if (!link) return;
      const restart = document.querySelector('[data-cb-rmatch] [data-cb-rmatch-restart], [data-cb-quiz-section] [data-cb-quiz-restart]');
      if (!restart) return;
      event.preventDefault();
      restart.click();
      const quiz = restart.closest('[data-cb-rmatch], [data-cb-quiz-section]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      quiz?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-finder-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CARD = '[data-cb-quiz]';
    const ADVANCE_DELAY = 350;
    const states = new WeakMap();

    const pad = (number) => String(number).padStart(2, '0');
    const fill = (template, values) =>
      (template || '').replace(/\[(\w+)\]/g, (token, key) => (key in values ? values[key] : token));
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const questionsOf = (card) => [...card.querySelectorAll('[data-cb-quiz-question]')];

    const setProgress = (card, current, total) => {
      const percent = total ? Math.round((current / total) * 100) : 0;
      card.style.setProperty('--cbq-progress', `${percent}%`);
      const label = card.querySelector('[data-cb-quiz-progress]');
      if (label) label.textContent = fill(card.dataset.progressLabel, { percent, current, total });
    };

    const show = (card, index, { focus = false } = {}) => {
      const state = states.get(card);
      const questions = questionsOf(card);
      if (!state || !questions[index]) return;
      state.index = index;
      card.classList.remove('is-complete');
      card.querySelector('[data-cb-quiz-results]')?.setAttribute('hidden', '');
      questions.forEach((question, i) => question.classList.toggle('is-active', i === index));
      const back = card.querySelector('[data-cb-quiz-back]');
      if (back) back.hidden = index === 0;
      setProgress(card, index + 1, questions.length);
      if (focus) questions[index].querySelector('[data-cb-quiz-title]')?.focus({ preventScroll: true });
    };

    // Scores each candidate racket by how many match words of the chosen answers it has (tags or title words).
    // Ties keep the collection's order, so with no matches at all the collection's first rackets are shown.
    const rank = (card, answers) => {
      const pool = card.querySelector('template[data-cb-quiz-pool]');
      if (!pool) return { items: [], matched: false };
      const terms = answers.flatMap((answer) => (answer?.dataset.match || '').split('|').filter(Boolean));
      const scored = [...pool.content.querySelectorAll('[data-cb-quiz-product]')].map((item, order) => {
        const keys = item.dataset.keys || '';
        const title = item.dataset.title || '';
        const score = terms.filter((term) => keys.includes(`|${term}|`) || title.includes(`-${term}-`)).length;
        return { item, order, score };
      });
      scored.sort((a, b) => b.score - a.score || a.order - b.order);
      const count = Number(card.dataset.resultsCount) || 3;
      return { items: scored.slice(0, count).map(({ item }) => item), matched: scored[0]?.score > 0 };
    };

    const showResults = (card) => {
      const state = states.get(card);
      const results = card.querySelector('[data-cb-quiz-results]');
      if (!state || !results) return;
      const { items, matched } = rank(card, state.answers);

      const list = results.querySelector('[data-cb-quiz-matches]');
      list.replaceChildren(...items.map((item) => document.importNode(item, true)));
      list.hidden = items.length === 0;

      const title = results.querySelector('[data-cb-quiz-results-title]');
      title.textContent = fill(matched ? title.dataset.matchTitle : title.dataset.fallbackTitle, { count: items.length });

      const summary = results.querySelector('[data-cb-quiz-summary]');
      if (summary) {
        summary.textContent = state.answers
          .filter(Boolean)
          .map((answer) => answer.querySelector('.cb-quiz-opt__title')?.textContent.trim())
          .join(' · ');
      }

      card.classList.add('is-complete');
      results.hidden = false;
      const back = card.querySelector('[data-cb-quiz-back]');
      if (back) back.hidden = false;
      const total = questionsOf(card).length;
      setProgress(card, total, total);
      title.focus({ preventScroll: true });
    };

    const restart = (card, { focus = true } = {}) => {
      const state = states.get(card);
      if (!state) return;
      clearTimeout(state.timer);
      state.answers = [];
      for (const option of card.querySelectorAll('[data-cb-quiz-option]')) option.setAttribute('aria-pressed', 'false');
      show(card, 0, { focus });
    };

    const init = (card) => {
      const questions = questionsOf(card);
      if (!questions.length) return;
      questions.forEach((question, i) => {
        const step = question.querySelector('[data-cb-quiz-step]');
        if (step) step.textContent = fill(card.dataset.stepLabel, { current: pad(i + 1), total: pad(questions.length) });
      });
      states.set(card, { index: 0, answers: [], timer: null });
      card.querySelector('[data-cb-quiz-questions]')?.classList.add('is-ready');
      show(card, 0);
      // Announce progress from now on (not the first fill on page load).
      card.querySelector('[data-cb-quiz-progress]')?.setAttribute('aria-live', 'polite');
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      // Choosing an answer marks it, then moves on to the next question (or the results).
      const option = event.target.closest('[data-cb-quiz-option]');
      if (option) {
        const card = option.closest(CARD);
        const state = card && states.get(card);
        const question = option.closest('[data-cb-quiz-question]');
        if (!state || !question) return;
        const questions = questionsOf(card);
        const index = questions.indexOf(question);
        for (const other of question.querySelectorAll('[data-cb-quiz-option]')) {
          other.setAttribute('aria-pressed', String(other === option));
        }
        state.answers[index] = option;
        clearTimeout(state.timer);
        state.timer = setTimeout(() => {
          if (index < questions.length - 1) show(card, index + 1, { focus: true });
          else showResults(card);
        }, reducedMotion() ? 0 : ADVANCE_DELAY);
        return;
      }

      const back = event.target.closest('[data-cb-quiz-back]');
      if (back) {
        const card = back.closest(CARD);
        const state = card && states.get(card);
        if (!state) return;
        clearTimeout(state.timer);
        const index = card.classList.contains('is-complete') ? questionsOf(card).length - 1 : state.index - 1;
        show(card, Math.max(0, index), { focus: true });
        return;
      }

      const again = event.target.closest('[data-cb-quiz-restart]');
      if (again) {
        const card = again.closest(CARD);
        if (card) restart(card);
        return;
      }

      // "Launch racket finder" without a link: start over and bring the card into view.
      const launch = event.target.closest('[data-cb-quiz-launch]');
      if (launch) {
        const card = launch.closest('[data-cb-quiz-section]')?.querySelector(CARD);
        if (!card || !states.get(card) || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        restart(card, { focus: false });
        const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        const box = card.getBoundingClientRect();
        if (box.top < headerHeight || box.bottom > window.innerHeight) {
          card.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
        card.querySelector('.cb-quiz-q.is-active [data-cb-quiz-title]')?.focus({ preventScroll: true });
      }
    });

    // Theme editor: selecting a question (or one of its answers) shows that question.
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest?.(CARD);
      const question = event.target.closest?.('[data-cb-quiz-question]');
      if (card && question && states.get(card)) show(card, questionsOf(card).indexOf(question));
    });

    const initAll = (root) => root.querySelectorAll(CARD).forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DROPDOWN = '.cb-header__dropdown';
    const DRAWER = '.cb-header__drawer';
    const canHover = () => window.matchMedia('(hover: hover)').matches;
    let closeTimer;

    const closeDropdowns = (except) => {
      for (const dropdown of document.querySelectorAll(`${DROPDOWN}[open]`)) {
        if (dropdown !== except) dropdown.open = false;
      }
    };

    // Dropdowns open on hover (as well as click) on devices with a mouse.
    document.addEventListener('mouseover', (event) => {
      const dropdown = event.target.closest?.(DROPDOWN);
      if (!dropdown || !canHover()) return;
      clearTimeout(closeTimer);
      closeDropdowns(dropdown);
      dropdown.open = true;
    });

    document.addEventListener('mouseout', (event) => {
      const dropdown = event.target.closest?.(DROPDOWN);
      if (!dropdown || !canHover() || dropdown.contains(event.relatedTarget)) return;
      closeTimer = setTimeout(() => {
        dropdown.open = false;
      }, 200);
    });

    // One dropdown at a time; lock page scrolling while the mobile menu is open.
    document.addEventListener(
      'toggle',
      (event) => {
        const element = event.target;
        if (!(element instanceof HTMLDetailsElement)) return;
        if (element.matches(DROPDOWN) && element.open) closeDropdowns(element);
        if (element.matches(DRAWER)) document.documentElement.classList.toggle('cb-header-drawer-open', element.open);
      },
      true
    );

    document.addEventListener('click', (event) => {
      for (const dropdown of document.querySelectorAll(`${DROPDOWN}[open]`)) {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      }

      // The search field opens the theme's predictive search window.
      const trigger = event.target.closest?.('[data-cb-search-trigger]');
      const modal = document.getElementById('search-modal');
      if (trigger && modal && typeof modal.showDialog === 'function') {
        event.preventDefault();
        modal.showDialog();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector(`${DROPDOWN}[open], ${DRAWER}[open]`);
      if (!open) return;
      open.open = false;
      open.querySelector('summary')?.focus();
    });

    // Theme editor: set the header up again after its section re-renders.
    document.addEventListener('shopify:section:load', (event) => {
      for (const header of event.target.querySelectorAll('.cb-header')) window.cbHeaderInit?.(header);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-racket-matcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT = '[data-cb-rmatch]';
    const states = new WeakMap();
    const fill = (template, values) => (template || '').replace(/\[(\w+)\]/g, (token, key) => (key in values ? values[key] : token));
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const parts = (root) => {
      const quiz = root.querySelector('[data-cb-rmatch-quiz]');
      return {
        quiz,
        questions: quiz ? [...quiz.querySelectorAll('[data-cb-rmatch-question]')] : [],
        results: root.querySelector('[data-cb-rmatch-results]'),
      };
    };

    // --- Ranking -----------------------------------------------------------------------------------------------
    // Each answer earns a racket 1 point when any of its traits match (plus a little per extra trait); a budget
    // answer ranks rackets inside its price range first. Ties keep the collection's order.
    const termsOf = (option) => (option?.dataset.match || '').split('|').filter(Boolean);
    const rank = (results, answers) => {
      const pool = results.querySelector('template[data-cb-rmatch-pool]');
      if (!pool) return [];
      const chosen = answers.filter(Boolean);
      const scored = [...pool.content.querySelectorAll('[data-cb-rmatch-product]')].map((item, order) => {
        const keys = item.dataset.keys || '';
        const price = Number(item.dataset.price) || 0;
        let score = 0;
        let budget = 0;
        const matched = [];
        for (const option of chosen) {
          const hits = termsOf(option).filter((term) => keys.includes(`|${term}|`)).length;
          if (hits) {
            score += 1 + 0.2 * (hits - 1);
            matched.push(option);
          }
          const min = option.dataset.min ? Number(option.dataset.min) : null;
          const max = option.dataset.max ? Number(option.dataset.max) : null;
          if (min !== null || max !== null) {
            const inside = (min === null || price >= min) && (max === null || price <= max);
            budget += inside ? 1 : -1;
            if (inside) matched.push(option);
          }
        }
        return { item, order, score, budget, matched };
      });
      scored.sort((a, b) => b.budget - a.budget || b.score - a.score || a.order - b.order);
      const count = Number(results.dataset.count) || 3;
      return scored.slice(0, count);
    };

    const optionTitle = (option) => option.querySelector('.cb-rmatch-opt__title')?.textContent.trim() || '';

    const renderResults = (root, answers) => {
      const { results } = parts(root);
      if (!results) return 0;
      const ranked = rank(results, answers);
      const grid = results.querySelector('[data-cb-rmatch-grid]');
      const labels = (results.dataset.otherLabels || '').split('|');
      const cards = ranked.map(({ item, matched }, i) => {
        const card = document.importNode(item, true);
        card.classList.toggle('is-best', i === 0);
        card.dataset.index = String(i);
        const style = card.dataset.style;
        const label = i === 0 ? results.dataset.bestLabel : labels[i - 1] || labels[labels.length - 1] || '';
        const tag = card.querySelector('[data-cb-rmatch-tag]');
        if (tag) tag.textContent = [style, label].filter(Boolean).join(' · ');
        const why = card.querySelector('[data-cb-rmatch-why]');
        if (why) {
          const names = [...new Set(matched.map(optionTitle))].filter(Boolean);
          why.textContent = card.dataset.why || (names.length ? fill(results.dataset.whyPrefix, { answers: names.join(' · ') }) : results.dataset.whyFallback);
        }
        return card;
      });
      grid.replaceChildren(...cards);
      grid.style.setProperty('--cbrm-columns', String(Math.max(cards.length, 1)));
      root.style.setProperty('--cbrm-columns', String(Math.max(cards.length, 1)));
      for (const el of root.querySelectorAll('[data-cb-rmatch-count]')) el.textContent = String(cards.length);
      renderTable(results, cards);
      return cards.length;
    };

    const renderTable = (results, cards) => {
      const table = results.querySelector('[data-cb-rmatch-table]');
      if (!table) return;
      const [style, level, weight, balance, flex, price] = (results.dataset.rows || '').split('|');
      const rows = [
        [style, 'style'],
        [level, 'level'],
        [weight, 'weight'],
        [balance, 'balance'],
        [flex, 'flex'],
      ].filter(([label]) => label);
      const cell = (tag, text, best, scope) => {
        const el = document.createElement(tag);
        el.textContent = text;
        if (best) el.classList.add('is-best');
        if (scope) el.scope = scope;
        return el;
      };
      const thead = document.createElement('thead');
      const head = document.createElement('tr');
      head.append(cell('th', results.dataset.firstCol || '', false, 'col'));
      cards.forEach((card, i) => {
        const name = card.dataset.title + (i === 0 && results.dataset.bestSuffix ? ` ${results.dataset.bestSuffix}` : '');
        head.append(cell('th', name, i === 0, 'col'));
      });
      thead.append(head);
      const tbody = document.createElement('tbody');
      for (const [label, key] of rows) {
        const tr = document.createElement('tr');
        tr.append(cell('th', label, false, 'row'));
        cards.forEach((card, i) => tr.append(cell('td', card.dataset[key] || '—', i === 0)));
        tbody.append(tr);
      }
      if (price) {
        const tr = document.createElement('tr');
        tr.className = 'is-price';
        tr.append(cell('th', price, false, 'row'));
        cards.forEach((card, i) => tr.append(cell('td', card.dataset.money || '', i === 0)));
        tbody.append(tr);
      }
      table.replaceChildren(thead, tbody);
    };

    // --- Quiz ----------------------------------------------------------------------------------------------------
    const show = (root, index, { focus = false } = {}) => {
      const state = states.get(root);
      const { quiz, questions } = parts(root);
      if (!state || !quiz || !questions[index]) return;
      state.index = index;
      quiz.classList.remove('is-complete');
      quiz.querySelector('[data-cb-rmatch-done]').hidden = true;
      questions.forEach((question, i) => question.classList.toggle('is-active', i === index));
      const total = questions.length;
      quiz.style.setProperty('--cbrm-progress', `${Math.round(((index + 1) / total) * 100)}%`);
      quiz.querySelector('[data-cb-rmatch-progress]').textContent = fill(quiz.dataset.progressLabel, { current: index + 1, total });
      const step = questions[index].dataset.step;
      quiz.querySelector('[data-cb-rmatch-step]').textContent = step ? fill(quiz.dataset.stepLabel, { step }) : '';
      quiz.querySelector('[data-cb-rmatch-back]').hidden = index === 0;
      quiz.querySelector('[data-cb-rmatch-skip]').hidden = false;
      quiz.querySelector('[data-cb-rmatch-restart]').hidden = true;
      quiz.querySelector('[data-cb-rmatch-continue-text]').textContent = index === total - 1 ? quiz.dataset.finishLabel : quiz.dataset.continueLabel;
      if (focus) questions[index].querySelector('.cb-rmatch-q__title')?.focus({ preventScroll: true });
    };

    const setPill = (root, done, count) => {
      const { quiz, questions } = parts(root);
      const text = quiz?.querySelector('[data-cb-rmatch-pill-text]');
      if (!text) return;
      const template = done ? quiz.dataset.pillDone : quiz.dataset.pillPending;
      text.textContent = fill(template, { total: questions.length, count });
      text.closest('[data-cb-rmatch-pill]').hidden = !template;
    };

    const finish = (root) => {
      const state = states.get(root);
      const { quiz, questions, results } = parts(root);
      if (!state || !quiz) return;
      const count = renderResults(root, state.answers);
      quiz.classList.add('is-complete');
      const done = quiz.querySelector('[data-cb-rmatch-done]');
      done.hidden = false;
      quiz.querySelector('[data-cb-rmatch-summary]').textContent = state.answers.filter(Boolean).map(optionTitle).join(' · ');
      quiz.style.setProperty('--cbrm-progress', '100%');
      quiz.querySelector('[data-cb-rmatch-progress]').textContent = fill(quiz.dataset.progressLabel, { current: questions.length, total: questions.length });
      quiz.querySelector('[data-cb-rmatch-step]').textContent = '';
      quiz.querySelector('[data-cb-rmatch-skip]').hidden = true;
      quiz.querySelector('[data-cb-rmatch-restart]').hidden = false;
      quiz.querySelector('[data-cb-rmatch-back]').hidden = false;
      setPill(root, true, count);
      if (results) {
        results.hidden = false;
        results.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        results.querySelector('[data-cb-rmatch-results-heading]')?.focus({ preventScroll: true });
      }
    };

    const restart = (root) => {
      const state = states.get(root);
      const { quiz, results } = parts(root);
      if (!state || !quiz) return;
      state.answers = [];
      for (const option of quiz.querySelectorAll('[data-cb-rmatch-option]')) option.setAttribute('aria-checked', 'false');
      if (results && !window.Shopify?.designMode) results.hidden = true;
      setPill(root, false, 0);
      show(root, 0, { focus: true });
      quiz.querySelector('.cb-rmatch-quiz__card')?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    };

    const next = (root) => {
      const state = states.get(root);
      const { questions } = parts(root);
      if (!state) return;
      if (state.index >= questions.length - 1) finish(root);
      else show(root, state.index + 1, { focus: true });
    };

    const init = (root) => {
      const { quiz, questions, results } = parts(root);
      if (quiz && questions.length) {
        states.set(root, { index: 0, answers: [] });
        quiz.querySelector('[data-cb-rmatch-questions]')?.classList.add('is-ready');
        show(root, 0);
        setPill(root, false, 0);
      }
      // In the theme editor, show sample results (no answers yet) so they can be styled.
      if (results && window.Shopify?.designMode) renderResults(root, []);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const root = event.target.closest(ROOT);
      if (!root) return;
      const state = states.get(root);

      const option = event.target.closest('[data-cb-rmatch-option]');
      if (option && state) {
        const question = option.closest('[data-cb-rmatch-question]');
        for (const other of question.querySelectorAll('[data-cb-rmatch-option]')) other.setAttribute('aria-checked', String(other === option));
        state.answers[parts(root).questions.indexOf(question)] = option;
        return;
      }
      if (event.target.closest('[data-cb-rmatch-continue]') && state) {
        if (parts(root).quiz.classList.contains('is-complete')) {
          parts(root).results?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        next(root);
        return;
      }
      if (event.target.closest('[data-cb-rmatch-skip]') && state) {
        state.answers[state.index] = null;
        const question = parts(root).questions[state.index];
        for (const other of question.querySelectorAll('[data-cb-rmatch-option]')) other.setAttribute('aria-checked', 'false');
        next(root);
        return;
      }
      if (event.target.closest('[data-cb-rmatch-back]') && state) {
        const { quiz, questions } = parts(root);
        if (quiz.classList.contains('is-complete')) show(root, questions.length - 1, { focus: true });
        else if (state.index > 0) show(root, state.index - 1, { focus: true });
        return;
      }
      if (event.target.closest('[data-cb-rmatch-restart]')) {
        restart(root);
        return;
      }
      // Compare: scroll to the table and briefly highlight this racket's column.
      const compare = event.target.closest('[data-cb-rmatch-compare-btn]');
      if (compare) {
        const card = compare.closest('[data-cb-rmatch-product]');
        const table = root.querySelector('[data-cb-rmatch-compare]');
        if (!table) return;
        table.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        const column = Number(card?.dataset.index) + 2;
        const cells = table.querySelectorAll(`tr > :nth-child(${column})`);
        cells.forEach((c) => c.classList.add('is-flash'));
        setTimeout(() => cells.forEach((c) => c.classList.remove('is-flash')), 1600);
      }
    });

    // Arrow keys move between answers inside a question (radio group behaviour).
    document.addEventListener('keydown', (event) => {
      const option = event.target.closest?.('[data-cb-rmatch-option]');
      if (!option || !['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
      const options = [...option.closest('[role="radiogroup"]').querySelectorAll('[data-cb-rmatch-option]')];
      const step = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
      const target = options[(options.indexOf(option) + step + options.length) % options.length];
      event.preventDefault();
      target.focus();
      target.click();
    });

    // Theme editor: selecting a question block shows it.
    document.addEventListener('shopify:block:select', (event) => {
      const question = event.target.closest?.('[data-cb-rmatch-question]');
      const root = question?.closest(ROOT);
      if (!root) return;
      show(root, parts(root).questions.indexOf(question));
    });

    const initAll = () => document.querySelectorAll(ROOT).forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector?.(ROOT);
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-tactics"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // A style card with a filter value filters the next [CB] Featured frames section further down the
    // page and scrolls to it. Without such a section (or a filter value) the card simply opens its link.
    // A card that filters the [CB] Product catalogue is left to the catalogue's script.
    document.addEventListener('click', (event) => {
      const card = event.target.closest?.('[data-cb-tactic]');
      const root = card?.closest('[data-cb-tactics]');
      if (!root || card.hasAttribute('data-cb-cat-filter') || event.metaKey || event.ctrlKey || event.shiftKey) return;

      const target = [...document.querySelectorAll('[data-cb-frames]')].find(
        (frames) => root.compareDocumentPosition(frames) & Node.DOCUMENT_POSITION_FOLLOWING
      );
      if (!target) return;

      event.preventDefault();
      for (const other of root.querySelectorAll('.cb-tactic')) {
        const active = other === card;
        other.classList.toggle('is-active', active);
        if (active) other.setAttribute('aria-current', 'true');
        else other.removeAttribute('aria-current');
      }
      target.dispatchEvent(new CustomEvent('cb:frames-filter', { bubbles: true, detail: { value: card.dataset.cbTactic } }));
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
